import { Pipe, PipeTransform } from '@angular/core';
import { GreetingIciTypeEnum } from 'src/app/components/settings/global-settings/greeting-settings/greeting-ici-type-enum';

@Pipe({
   name: 'iciTypeByName',
})
export class IciTypeByNamePipe implements PipeTransform {
   transform(iciName: string): GreetingIciTypeEnum {
      return GreetingIciTypeEnum.valueByName(iciName);
   }
}
